const courseManagement = {
    state: {
      tabName: 'courseQACenter',
      headquarters: '',
        headquartersCourseObj: {
            courseName: null,
            courseSeries: null,
            fileName: null,
            garden: null
        },
        gardenCourseObj: {
            // id: row.id,
            // key: res.data.key,
            // fileName: row.fileName,
            // source: 'garden'
        },
        classCourseObj: {
            // id: row.id,
            // key: res.data.key,
            // fileName: row.fileName,
            // source: 'garden'
        }
    },
    mutations: {
      SET_HEADQUARTERS_COURSE_PARAMS: (state, obj) => {
        state.headquartersCourseObj = obj;
      },
      CHANGE_TABNAME: (state, status) => {
        state.tabName = status;
      },
      GET_HEADQUARTERS: (state, status) => {
        state.headquarters = status;
      }
    },
    actions: {
      
    }
  }
  
  export default courseManagement


// WEBPACK FOOTER //
// ./src/store/modules/courseManagement/courseManagement.js